import { render, staticRenderFns } from "./farm.vue?vue&type=template&id=7c2aa3bb"
import script from "./farm.vue?vue&type=script&lang=js"
export * from "./farm.vue?vue&type=script&lang=js"
import style0 from "./farm.vue?vue&type=style&index=0&id=7c2aa3bb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports